import { scrollContainerMediaQuery } from '@theme/scroll-container';

// Videowise listens to window/body scroll. The desktop page wrapper scrolls
// independently on Home as well as PDPs. Relay once per frame while any widget
// is pending, including app blocks inserted after this module initializes.
let frame = 0;
const cancel = () => {
  cancelAnimationFrame(frame);
  frame = 0;
};

document.addEventListener('scroll', (event) => {
  if (!scrollContainerMediaQuery.matches || !event.target.matches?.('.page-wrapper') || frame) return;
  const wrapper = event.target;
  frame = requestAnimationFrame(() => {
    frame = 0;
    if (!scrollContainerMediaQuery.matches) return;
    const pending = [...wrapper.querySelectorAll('.reeview-app-widget')].some(
      (widget) => widget.getBoundingClientRect().height <= 1,
    );
    if (pending) window.dispatchEvent(new Event('scroll'));
  });
}, { capture: true, passive: true });

window.addEventListener('pagehide', cancel);
scrollContainerMediaQuery.addEventListener('change', cancel);
